import React from 'react'
import "moment-timezone";
import momentDateAndTime from './../../../../../helpers/momentDateAndTime'

class DateFormater extends React.Component {
    render() {
        return (
            <span >
                Starts from
                <span style={{ verticalAlign: "top", margin: "0 0 0 2px" }}>
                    {momentDateAndTime(this.props.date)}
                </span>
            </span >
        )
    }
}

export default DateFormater;